import "@justworkshr/milo-tokens/build/css/tokens.css";
import styles from "./EditCard.module.css";
import React, { ReactElement, ReactNode } from "react";
import { SystemIcon } from "@justworkshr/milo-components";
export interface EditCardProps {
  title: string;
  description?: string | ReactNode;
  children: ReactNode;
  showEditIcon?: boolean;
  onEditClick?: () => void;
  hideBorder?: boolean;
}

const EditCard = ({
  title,
  description,
  children,
  onEditClick,
  showEditIcon = true,
  hideBorder,
}: EditCardProps): ReactElement => {
  const cardClassName = showEditIcon || hideBorder ? "" : styles.brandBorder;
  return (
    <div className={styles.editCardContainer}>
      <figure className={`${styles.editCard} ${cardClassName}`}>
        <figcaption className={styles.editCardHeader}>
          <div className={styles.headerFlex}>
            <h2 className={styles.editCardTitle}>{title}</h2>
            {showEditIcon && (
              <div
                data-testid="card-edit-button"
                className={styles.iconContainer}
                onClick={onEditClick}
              >
                <SystemIcon
                  iconName="edit"
                  color="brand"
                  title="Edit"
                  size="small"
                />
                <div className={styles.editIcon}>Edit</div>
              </div>
            )}
          </div>
          {description !== null && (
            <h3 className={styles.editCardDescription}>{description}</h3>
          )}
        </figcaption>
        <div className={styles.editCardContent}>{children}</div>
      </figure>
    </div>
  );
};

export default EditCard;
